<app-sub-header [pageTitle]="'NewServicePoint' | translate"></app-sub-header>

<div class="padded-container">
    
    <dx-select-box 
      [dataSource]="servicePointsResponse?.dioVisitedServicePointsList || []" 
      displayExpr="servicePointName"
      [(value)]="selectedModel"
      placeholder="{{ 'SelectServicePoint' | translate }}"
      class="full-width-button"
      [searchEnabled]="true"
      searchMode="contains">
    </dx-select-box>

    <dx-button text="{{ 'Proceed' | translate }}" type="danger" class="full-width-button" (click)="proceed()">
    </dx-button>
    <dx-button text="{{ 'Back' | translate }}" type="danger" class="full-width-button" (click)="navigateToServicePointManager()">
    </dx-button>

</div>